module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache1.0e0b9af2fb4edf9f522d62a4dae21763.png";